module.exports = __webpack_public_path__ + "img/coupon_en.6e19c91d.png";